import { render } from "./InquiryType.vue?vue&type=template&id=871e1040&scoped=true"
import script from "./InquiryType.vue?vue&type=script&lang=js"
export * from "./InquiryType.vue?vue&type=script&lang=js"

import "./InquiryType.vue?vue&type=style&index=0&id=871e1040&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-871e1040"]])

export default __exports__